export { cardVariables as cardPreviewVariables } from './cardVariables';
